// @flow

export const translations = {
    en: {
        // StartSaleOrderReturnRequestPage
        saleOrderReturnRequest: "Sale Order Return Request",
        startPageDescription: "Please enter the number of the sale order for which you want to return stock, and the last 4 digits of your phone number to confirm that you are the one who created that sale order.",
        saleOrderNumber: "Sale Order Number",
        last4DigitsPhone: "Last 4 Digits of Phone Number",
        submitting: "Submitting...",
        submit: "Submit",
        errorOccurred: "An error occurred while submitting the request.",

        // ManageSaleOrderReturnRequestPage
        requestReturnTitle: "Request a Return for Your Sale Order",
        requestReturnDescription: "Here you can request a return for your sale order",
        from: "from",
        orderedBy: "ordered by",
        guideMessage: "We will guide you through each step to ensure a smooth and hassle-free experience.",
        stepSelectProducts: "Select products and quantities to return",
        stepPickupLocation: "Pickup location",
        stepPickupDate: "Pickup date",
        stepConfirmEmail: "Confirm email",
        confirmEmailDescription: "Confirm your email, where you'll receive instructions how to leave products for return at the selected drop-off point.",
        continue: "Continue",
        allStepsCompleted: "All steps completed - you're finished",
        reset: "Reset",

        // ProductsToReturnStep
        productsDescription: "Here are products, that you've ordered. Select which one(s) and what quantity you want to return",
        stockOrderedQtyAmount: "Stock / Ordered qty, amount",
        qtyToReturn: "Qty to return",

        // PickupLocationStep
        selectPickupLocation: "Select the drop-off point, where you'll leave products for return",
        selectCountry: "Select country",
        selectCity: "Select city",
        selectLocker: "Select drop-off point",
        country: "Country",
        city: "City",
        locker: "Drop-off point",
        search: "Search",

        // PickupDateStep
        selectPickupDate: "Select pickup date, when you want to leave products to return into the selected pickup location",
        today: "Today",
        tomorrow: "Tomorrow",

        // ConfirmEmailStep
        confirmEmail: "Confirm Email",
        returnShippingSuccess: "Success! Return shipping has been generated and instructions have been sent to",

        // Completed state
        returnRequestCompleted: "You have already requested a stock return. Details have been sent to",
    },

    bg: {
        // StartSaleOrderReturnRequestPage
        saleOrderReturnRequest: "Заявка за връщане на поръчка",
        startPageDescription: "Моля, въведете номера на поръчката, за която искате да върнете стока, и последните 4 цифри от телефонния си номер, за да потвърдите, че вие сте създали тази поръчка.",
        saleOrderNumber: "Номер на поръчка",
        last4DigitsPhone: "Последни 4 цифри от телефонен номер",
        submitting: "Изпращане...",
        submit: "Изпрати",
        errorOccurred: "Възникна грешка при изпращане на заявката.",

        // ManageSaleOrderReturnRequestPage
        requestReturnTitle: "Заявка за връщане на вашата поръчка",
        requestReturnDescription: "Тук можете да заявите връщане на вашата поръчка",
        from: "от",
        orderedBy: "поръчана от",
        guideMessage: "Ще ви преведем през всяка стъпка, за да осигурим гладко и безпроблемно изживяване.",
        stepSelectProducts: "Изберете продукти и количества за връщане",
        stepPickupLocation: "Място за вземане",
        stepPickupDate: "Дата за вземане",
        stepConfirmEmail: "Потвърдете имейл",
        confirmEmailDescription: "Потвърдете вашия имейл, където ще получите инструкции как да оставите продуктите за връщане на избраното място за предаване.",
        continue: "Продължи",
        allStepsCompleted: "Всички стъпки са завършени - готово!",
        reset: "Нулиране",

        // ProductsToReturnStep
        productsDescription: "Ето продуктите, които сте поръчали. Изберете кой/кои и какво количество искате да върнете",
        stockOrderedQtyAmount: "Артикул / Поръчано кол., сума",
        qtyToReturn: "Кол. за връщане",

        // PickupLocationStep
        selectPickupLocation: "Изберете място за предаване, където ще оставите продуктите за връщане",
        selectCountry: "Изберете държава",
        selectCity: "Изберете град",
        selectLocker: "Изберете място за предаване",
        country: "Държава",
        city: "Град",
        locker: "Място за предаване",
        search: "Търсене",

        // PickupDateStep
        selectPickupDate: "Изберете дата за вземане, когато искате да оставите продуктите за връщане на избраното място",
        today: "Днес",
        tomorrow: "Утре",

        // ConfirmEmailStep
        confirmEmail: "Потвърди имейл",
        returnShippingSuccess: "Успех! Обратната доставка е генерирана и инструкциите са изпратени на",

        // Completed state
        returnRequestCompleted: "Вече сте заявили връщане на стока. Детайлите са изпратени на",
    },

    ro: {
        // StartSaleOrderReturnRequestPage
        saleOrderReturnRequest: "Cerere de returnare comandă",
        startPageDescription: "Vă rugăm să introduceți numărul comenzii pentru care doriți să returnați produsele și ultimele 4 cifre ale numărului dvs. de telefon pentru a confirma că dvs. ați creat această comandă.",
        saleOrderNumber: "Număr comandă",
        last4DigitsPhone: "Ultimele 4 cifre ale numărului de telefon",
        submitting: "Se trimite...",
        submit: "Trimite",
        errorOccurred: "A apărut o eroare la trimiterea cererii.",

        // ManageSaleOrderReturnRequestPage
        requestReturnTitle: "Solicitați o returnare pentru comanda dvs.",
        requestReturnDescription: "Aici puteți solicita o returnare pentru comanda dvs.",
        from: "din",
        orderedBy: "comandată de",
        guideMessage: "Vă vom ghida prin fiecare pas pentru a asigura o experiență lină și fără probleme.",
        stepSelectProducts: "Selectați produsele și cantitățile de returnat",
        stepPickupLocation: "Locație de ridicare",
        stepPickupDate: "Data de ridicare",
        stepConfirmEmail: "Confirmați email-ul",
        confirmEmailDescription: "Confirmați email-ul dvs., unde veți primi instrucțiuni despre cum să lăsați produsele pentru returnare la punctul de predare selectat.",
        continue: "Continuă",
        allStepsCompleted: "Toți pașii sunt finalizați - ați terminat!",
        reset: "Resetare",

        // ProductsToReturnStep
        productsDescription: "Iată produsele pe care le-ați comandat. Selectați care și ce cantitate doriți să returnați",
        stockOrderedQtyAmount: "Produs / Cantitate comandată, sumă",
        qtyToReturn: "Cantitate de returnat",

        // PickupLocationStep
        selectPickupLocation: "Selectați punctul de predare, unde veți lăsa produsele pentru returnare",
        selectCountry: "Selectați țara",
        selectCity: "Selectați orașul",
        selectLocker: "Selectați punctul de predare",
        country: "Țară",
        city: "Oraș",
        locker: "Punct de predare",
        search: "Căutare",

        // PickupDateStep
        selectPickupDate: "Selectați data de ridicare, când doriți să lăsați produsele pentru returnare la locația selectată",
        today: "Astăzi",
        tomorrow: "Mâine",

        // ConfirmEmailStep
        confirmEmail: "Confirmă email",
        returnShippingSuccess: "Succes! Transportul de returnare a fost generat și instrucțiunile au fost trimise la",

        // Completed state
        returnRequestCompleted: "Ați solicitat deja o returnare de stoc. Detaliile au fost trimise la",
    },

    el: {
        // StartSaleOrderReturnRequestPage
        saleOrderReturnRequest: "Αίτημα επιστροφής παραγγελίας",
        startPageDescription: "Παρακαλώ εισάγετε τον αριθμό της παραγγελίας για την οποία θέλετε να επιστρέψετε προϊόντα και τα τελευταία 4 ψηφία του τηλεφώνου σας για να επιβεβαιώσετε ότι εσείς δημιουργήσατε αυτή την παραγγελία.",
        saleOrderNumber: "Αριθμός παραγγελίας",
        last4DigitsPhone: "Τελευταία 4 ψηφία τηλεφώνου",
        submitting: "Υποβολή...",
        submit: "Υποβολή",
        errorOccurred: "Παρουσιάστηκε σφάλμα κατά την υποβολή του αιτήματος.",

        // ManageSaleOrderReturnRequestPage
        requestReturnTitle: "Αίτημα επιστροφής για την παραγγελία σας",
        requestReturnDescription: "Εδώ μπορείτε να ζητήσετε επιστροφή για την παραγγελία σας",
        from: "από",
        orderedBy: "παραγγέλθηκε από",
        guideMessage: "Θα σας καθοδηγήσουμε σε κάθε βήμα για να εξασφαλίσουμε μια ομαλή και χωρίς προβλήματα εμπειρία.",
        stepSelectProducts: "Επιλέξτε προϊόντα και ποσότητες για επιστροφή",
        stepPickupLocation: "Τοποθεσία παραλαβής",
        stepPickupDate: "Ημερομηνία παραλαβής",
        stepConfirmEmail: "Επιβεβαίωση email",
        confirmEmailDescription: "Επιβεβαιώστε το email σας, όπου θα λάβετε οδηγίες για το πώς να αφήσετε τα προϊόντα για επιστροφή στο επιλεγμένο σημείο παράδοσης.",
        continue: "Συνέχεια",
        allStepsCompleted: "Όλα τα βήματα ολοκληρώθηκαν - τελειώσατε!",
        reset: "Επαναφορά",

        // ProductsToReturnStep
        productsDescription: "Εδώ είναι τα προϊόντα που παραγγείλατε. Επιλέξτε ποιο/ποια και τι ποσότητα θέλετε να επιστρέψετε",
        stockOrderedQtyAmount: "Προϊόν / Παραγγελθείσα ποσ., ποσό",
        qtyToReturn: "Ποσ. για επιστροφή",

        // PickupLocationStep
        selectPickupLocation: "Επιλέξτε σημείο παράδοσης, όπου θα αφήσετε τα προϊόντα για επιστροφή",
        selectCountry: "Επιλέξτε χώρα",
        selectCity: "Επιλέξτε πόλη",
        selectLocker: "Επιλέξτε σημείο παράδοσης",
        country: "Χώρα",
        city: "Πόλη",
        locker: "Σημείο παράδοσης",
        search: "Αναζήτηση",

        // PickupDateStep
        selectPickupDate: "Επιλέξτε ημερομηνία παραλαβής, πότε θέλετε να αφήσετε τα προϊόντα για επιστροφή στην επιλεγμένη τοποθεσία",
        today: "Σήμερα",
        tomorrow: "Αύριο",

        // ConfirmEmailStep
        confirmEmail: "Επιβεβαίωση email",
        returnShippingSuccess: "Επιτυχία! Η αποστολή επιστροφής δημιουργήθηκε και οι οδηγίες έχουν σταλεί στο",

        // Completed state
        returnRequestCompleted: "Έχετε ήδη ζητήσει επιστροφή αποθέματος. Οι λεπτομέρειες έχουν σταλεί στο",
    },
};

export type Language = 'en' | 'bg' | 'ro' | 'el';

export const getTranslation = (lang: Language, key: string): string => {
    return translations[lang]?.[key] || translations.en[key] || key;
};
